import React from "react";

const ArrowUpRightIcon:React.FC = () => (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      className="w-4 h-4"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.33301 10.6667L10.6663 1.33337M10.6663 1.33337H3.66634M10.6663 1.33337V8.33337"
        stroke="#12B76A"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

export default ArrowUpRightIcon;
